export default __webpack_public_path__ + "static/media/section0-bg1.dd19795b.png";